import React, { useCallback } from "react";
import Checkbox from "@ui-kit/form/checkbox";
import Line from "@radarly/components/panels/card-edition/sidebar/line";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { DateMetricsCard } from "@radarly/models/cards";
import {
  DatavizDoubleTimeChart,
  updateDatavizOptions,
} from "@radarly/models/dataviz";
import TimeUnitOption from "@radarly/shared/panels/card-edition/sidebar/shared/time-unit";
export interface SharedPanelsCardEditionSidebarOptionsDatavizDoubleTimeChartProps {
  dataviz: DatavizDoubleTimeChart;
  setDataviz: (dataviz: DatavizDoubleTimeChart) => void;
  card: DateMetricsCard;
  setCard: (card: DateMetricsCard) => void;
}

export default function SharedPanelsCardEditionSidebarOptionsDoubleTimeChart({
  dataviz,
  setDataviz,
  card,
  setCard,
}: SharedPanelsCardEditionSidebarOptionsDatavizDoubleTimeChartProps) {
  const locale = useCurrentUserLocale();
  const updateDisplayVolumes = useCallback(() => {
    const value = dataviz.displayVolumes ? false : true;
    setDataviz(
      updateDatavizOptions(
        dataviz,
        "displayVolumes",
        value as DatavizDoubleTimeChart["displayVolumes"]
      )
    );
  }, [dataviz, setDataviz]);

  return (
    <>
      <Line title={tr(locale, "CUSTOM_PAGES::EDITOR::CARD_LEGEND")}>
        <Checkbox
          label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::DISPLAY_VOLUMES")}
          checked={dataviz.displayVolumes || undefined}
          onClick={updateDisplayVolumes}
        />
      </Line>
      <TimeUnitOption dataviz={dataviz} card={card} setCard={setCard} />
    </>
  );
}
